import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const Layout = () => {
  const { auth } = useAuth();

  if (!auth.token) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <TopBar />
        <div className="flex-1 overflow-auto p-4 mt-16 ml-64">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
